import { useState as f, useEffect as u } from "react";
import { registerStoryblokBridge as p } from "./storyblok-js.mjs";
const g = (e = null, s = {}) => {
  let [t, o] = f(e);
  const r = typeof window < "u" && typeof window.storyblokRegisterEvent < "u";
  return u(() => {
    if (!r || !e)
      return;
    const d = t.internalId || t.id;
    o(e), p(
      d,
      (n) => o(n),
      s
    );
  }, [e, r, t]), !r || !e ? e : t;
};
export {
  g as useStoryblokState
};
